import { render } from "./TaskFilters.vue?vue&type=template&id=357b2f41&scoped=true"
import script from "./TaskFilters.vue?vue&type=script&lang=js"
export * from "./TaskFilters.vue?vue&type=script&lang=js"

import "./TaskFilters.vue?vue&type=style&index=0&id=357b2f41&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-357b2f41"

export default script